// Psychologist/PsychologistDetailPage.tsx
import React from 'react';
import PsychologistDetail from "./PsychologistDetail";
import {FC} from "WideLayout/Layouts";
import {headerHeight} from "Core/components/Header/Header";
import {useSelector} from "react-redux";
import {RootState} from "Redux/store";

interface PsychologistDetailPageProps {
    containerRef?: React.RefObject<HTMLDivElement>;
}


const PsychologistDetailPage: React.FC<PsychologistDetailPageProps> = ({containerRef}) => {
    const pageRef = React.useRef<HTMLDivElement>(null);
    const isHeaderVisible = useSelector((state: RootState) => state.visibility.isHeaderVisible);

    return (<FC ref={pageRef} sx={{
        minHeight: isHeaderVisible ? `calc(100vh - ${headerHeight}px)` : '100vh',
        maxHeight: isHeaderVisible ? `calc(100vh - ${headerHeight}px)` : '100vh',
    }} cls={'no-scrollbar overflow-y-scroll'}>
        <FC>
            <PsychologistDetail
                containerRef={pageRef}
                className={'w-100 overflow-y-hidden'}/>
        </FC>
    </FC>);
};

export default PsychologistDetailPage;
